import { render, staticRenderFns } from "./NewIssueDialog.vue?vue&type=template&id=694109e1&scoped=true&"
import script from "./NewIssueDialog.vue?vue&type=script&lang=js&"
export * from "./NewIssueDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewIssueDialog.vue?vue&type=style&index=0&id=694109e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694109e1",
  null
  
)

component.options.__file = "NewIssueDialog.vue"
export default component.exports